module.exports = __webpack_public_path__ + "images/icons/lightning-8c1672d05c6b745798c8771bca027f38.svg";